// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__JuAIF","list":"BalanceDue_list__1bYUY","listRow":"BalanceDue_listRow__1fIBK","total":"BalanceDue_total__rWw6o"};